import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let GiftsPop = class GiftsPop extends Vue {
    hide() {
        this.$emit('update:isGiftsPopShow', false);
    }
};
tslib_1.__decorate([
    Prop({ default: false })
], GiftsPop.prototype, "isGiftsPopShow", void 0);
tslib_1.__decorate([
    Prop()
], GiftsPop.prototype, "giftsInfo", void 0);
tslib_1.__decorate([
    Prop({ default: 1 })
], GiftsPop.prototype, "baseNum", void 0);
GiftsPop = tslib_1.__decorate([
    Component
], GiftsPop);
export default GiftsPop;
